import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import * as styles from './styles.module.scss'

const Button = (props) => {
  const { children, className, href, style, target } = props

  return (
    <a
      className={classnames(styles.root, className)}
      href={href}
      style={style}
      target={target}
      rel="noreferrer"
    >
      {children}
    </a>
  )
}

Button.propTypes = {
  children: PropTypes.node,
}

export default Button
